// Cross-tab logout (contract 06 §7/§14): an EXPLICIT BroadcastChannel session-reset message
// with a plain localStorage event-key fallback for unsupported browsers. Other tabs run the
// same idempotent reset path once — we do NOT rely on mutations inside the encrypted secure-ls
// blob producing a usable event.
const CHANNEL_NAME = 'orphex-auth'
const RESET_MESSAGE = 'session-reset'
const FALLBACK_KEY = 'orphex-auth:reset'

function openChannel(): BroadcastChannel | null {
  return typeof BroadcastChannel === 'undefined' ? null : new BroadcastChannel(CHANNEL_NAME)
}

/** Broadcast a logout to other tabs. Opens a short-lived channel or bumps the fallback key. */
export function publishSessionReset(now: number): void {
  const channel = openChannel()
  if (channel) {
    channel.postMessage(RESET_MESSAGE)
    channel.close()
    return
  }
  try {
    localStorage.setItem(FALLBACK_KEY, String(now))
  } catch {
    /* storage unavailable — nothing more we can do */
  }
}

/** Listen for another tab's logout. Returns an unsubscribe fn. */
export function subscribeSessionReset(onReset: () => void): () => void {
  const channel = openChannel()
  if (channel) {
    const handler = (event: MessageEvent): void => {
      if (event.data === RESET_MESSAGE) onReset()
    }
    channel.addEventListener('message', handler)
    return () => {
      channel.removeEventListener('message', handler)
      channel.close()
    }
  }
  const handler = (event: StorageEvent): void => {
    if (event.key === FALLBACK_KEY) onReset()
  }
  window.addEventListener('storage', handler)
  return () => window.removeEventListener('storage', handler)
}
